import { FormControl } from '@angular/forms';

export const noWhitespaceValidator = (control: FormControl) => {
  const isWhitespace = !(control.value || '').trim().length;
  return isWhitespace && { required: true };
};
